import { Bell } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Notifications({ loggedIn, notificationCount }) {
  return (
    <>
      {loggedIn && (
        <Link
          className="relative cursor-pointer mr-2 sm:mr-0"
          to="/notifications"
        >
          {notificationCount > 0 && (
            <span
              className="absolute -top-3 -right-2 min-w-[18px] h-[18px] px-1
      bg-red-500 text-white text-[10px] font-semibold rounded-full
      flex items-center justify-center leading-none"
            >
              {notificationCount}
            </span>
          )}

          <Bell
            size={22}
            className="text-dim-600 hover:text-dim-900 transition-colors"
            aria-label="Notifications"
          />
        </Link>
      )}
    </>
  );
}
